import {AfterViewChecked, Component, OnInit, ViewChild} from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-modal-disposition-map',
  templateUrl: './modal-disposition-map.component.html',
  styles: []
})
export class ModalDispositionMapComponent extends ExcTranslation implements OnInit, AfterViewChecked {
  @ViewChild('mapInstance') mapContainer: any;
  mapObjects = {Auditor: null, Audit: null, SelectedAudits: []};
  selection = {Audits: [], Auditor: null, Audit: null, Month: (new  Date()).getMonth() + 1, Year: (new Date().getFullYear())};
  runOnce = true;
  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef) {
    super();
    const _self = this;
  }
  ngAfterViewChecked(): void {
    const _self = this;
    if (this.runOnce) {
      this.runOnce = false;
      setTimeout(() => { _self.updateMap(); }, 150 );
    }
  }

  ngOnInit() {
    const _self = this;
    _self.selection =  _self.overlayConfig.data.selection;
  }

  updateMap() {
    const _self = this;
    if (_self.mapContainer !== undefined) {
      if (_self.mapObjects.Auditor !== null) {
        _self.mapObjects.Auditor.setMap(null);
        _self.mapObjects.Auditor = null;
      }
      if (_self.mapObjects.Audit !== null) {
        _self.mapObjects.Audit.setMap(null);
        _self.mapObjects.Audit = null;
      }
      for (const x of _self.mapObjects.SelectedAudits) {
        x.setMap(null);
      }
      _self.mapObjects.SelectedAudits = [];


      if (_self.selection.Audit === null || _self.selection.Auditor === null) {
        return;
      }
      const bnds = new google.maps.LatLngBounds();
      if (_self.selection.Audit.DealerLatitude !== null && _self.selection.Audit.DealerLatitude !== 0) {
        const focus = new google.maps.LatLng(_self.selection.Audit.DealerLatitude, _self.selection.Audit.DealerLongitude);
        _self.mapObjects.Audit = new google.maps.Marker({
          position: focus,
          map: _self.mapContainer.map,
          icon: {url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'}
        });
        bnds.extend(focus);
      }
      if (_self.selection.Auditor.AdmLat !== null && _self.selection.Auditor.AdmLng !== 0) {
        const auditor = new google.maps.LatLng(_self.selection.Auditor.AdmLat, _self.selection.Auditor.AdmLng);
        _self.mapObjects.Auditor = new google.maps.Marker({position: auditor, map: _self.mapContainer.map});
        bnds.extend(auditor);
      }
      // if (_self.selection.Audit.DealerLatitude !== null && _self.selection.Audit.DealerLatitude !== 0) {
      //   const pos = new google.maps.LatLng(_self.selection.Audit.DealerLatitude, _self.selection.Audit.DealerLongitude);
      //   const m = new google.maps.Marker({
      //     position: pos,
      //     map: _self.mapContainer.map,
      //     icon: {url: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'}
      //   });
      //   bnds.extend(pos);
      // }
      _self.mapContainer.map.fitBounds(bnds);
    }
  }

}
